/* 0.48.22 - Armenian "և" in capital letters is "ԵՎ".
 *
 * Browsers follow Unicode, which writes "և" in capitals as "ԵՒ" (the
 * old spelling). So wherever the platform shows text in capitals with
 * CSS (a status badge, a chip with capitals, a stepper's labels), "և"
 * came out as "ԵՒ". CSS cannot be told otherwise, so the text itself
 * is fixed: in an element shown in capitals, "և" becomes "եվ", which
 * the browser then capitalises as "ԵՎ". Text not shown in capitals is
 * never touched.
 *
 * Only text that holds "և" is looked at, so the cost is nil on pages
 * without it. upperHy() is the same rule for code that capitalises
 * text itself (the upper() formula). */

const YEV = /և/g;

export function upperHy(value) {
  return String(value).replace(YEV, 'ԵՎ').toUpperCase();
}

function fixText(node) {
  const v = node.nodeValue;
  if (!v || v.indexOf('և') < 0) return;
  const el = node.parentElement;
  if (!el) return;
  let up = false;
  try { up = getComputedStyle(el).textTransform === 'uppercase'; } catch { up = false; }
  if (up) node.nodeValue = v.replace(YEV, 'եվ');
}

function fixTree(root) {
  if (!root) return;
  if (root.nodeType === 3) { fixText(root); return; }
  if (root.nodeType !== 1 || !(root.textContent || '').includes('և')) return;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode: (n) => (n.nodeValue && n.nodeValue.indexOf('և') >= 0
      ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP),
  });
  const found = [];
  while (walker.nextNode()) found.push(walker.currentNode);
  found.forEach(fixText);
}

let installed = false;
export function installArmenianCaps() {
  if (installed || typeof window === 'undefined' || typeof MutationObserver === 'undefined') return;
  installed = true;
  const start = () => {
    fixTree(document.body);
    new MutationObserver((list) => {
      for (const m of list) {
        if (m.type === 'characterData') fixText(m.target);
        else if (m.type === 'attributes') fixTree(m.target);
        else m.addedNodes.forEach(fixTree);
      }
    }).observe(document.body, {
      subtree: true, childList: true, characterData: true,
      // A class change can switch capitals on (a badge restyled).
      attributes: true, attributeFilter: ['class', 'style'],
    });
  };
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
}

installArmenianCaps();
